export default "__VITE_ASSET__C0x4C9Gz__"